var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classNames from 'classnames';
import DescriptionListItem from 'components/v2/DescriptionListItem';
import EditableSection from 'components/v2/EditableSection';
import Select from 'components/v2/select';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
const ShorthaulOperations = ({ data, onUpdateShipper, className }) => {
    const { t } = useTranslation();
    const [initialData, setInitialData] = useState({});
    const [shorthaulOpsData, setShorthaulOpsData] = useState({});
    const getInitialData = () => {
        if (data) {
            setInitialData(data);
            setShorthaulOpsData(data);
        }
    };
    useEffect(() => {
        getInitialData();
    }, []);
    const onChange = (field, value) => {
        setShorthaulOpsData((prev) => (Object.assign(Object.assign({}, prev), { [field]: value })));
    };
    const handleSave = async () => {
        const updates = {};
        const { admins } = shorthaulOpsData, changed = __rest(shorthaulOpsData, ["admins"]);
        Object.keys(changed).forEach((key) => {
            if (initialData[key] !== changed[key]) {
                updates[key] = changed[key];
            }
        });
        if (Object.keys(updates).length) {
            await onUpdateShipper(updates);
        }
    };
    const handleAfterSave = (onSaveSuccess) => {
        return (updatedData = {}) => {
            setInitialData((prev) => (Object.assign(Object.assign({}, prev), updatedData)));
            onSaveSuccess();
        };
    };
    return (React.createElement(EditableSection, { title: t('SHORTHAUL_OPERATIONS'), className: classNames(className), canEdit: true }, (editing, saving, onSaveSuccess, onSaveFail) => !editing ? (React.createElement(ShorthaulOperationsSummary, { fields: initialData })) : (React.createElement(ShorthaulOperationsForm, { fields: shorthaulOpsData, onChange: onChange, onSaveShipper: () => handleSave(), saving: saving, onSaveSuccess: handleAfterSave(onSaveSuccess), onSaveFail: onSaveFail }))));
};
const ShorthaulOperationsSummary = ({ fields = {} }) => {
    const { operations_manager, customer_success_manager } = fields;
    const { t } = useTranslation();
    const na = t('NONE');
    return (React.createElement("div", { className: "grid grid-cols-1 gap-4" },
        React.createElement(DescriptionListItem, { label: t('OPERATIONS_MANAGER') }, operations_manager || na),
        React.createElement(DescriptionListItem, { label: t('CUSTOMER_SUCCESS_MANAGER') }, customer_success_manager || na)));
};
const ShorthaulOperationsForm = ({ fields, onChange, saving, onSaveShipper, onSaveSuccess, onSaveFail, }) => {
    const { t } = useTranslation();
    const saveForm = async () => {
        try {
            await onSaveShipper();
            onSaveSuccess(fields);
        }
        catch (e) {
            onSaveFail();
        }
    };
    useEffect(() => {
        if (saving) {
            saveForm();
        }
    }, [saving]);
    const { admins } = fields;
    return (React.createElement("div", { className: "grid grid-cols-1 gap-4" },
        React.createElement(Select, { items: admins, valueKey: "slug", textKey: "name", selected: fields.operations_manager, onSelect: ({ slug }) => onChange('operations_manager', slug), inputClassNames: "lg:w-4/5 w-1/2", info: t('THE_OPERATIONS_MANAGER'), label: t('OPERATIONS_MANAGER') }),
        React.createElement(Select, { items: admins, valueKey: "slug", textKey: "name", selected: fields.customer_success_manager, onSelect: ({ slug }) => onChange('customer_success_manager', slug), inputClassNames: "lg:w-4/5 w-1/2", info: t('THE_CUSTOMER_SUCCESS_MANAGER'), label: t('CUSTOMER_SUCCESS_MANAGER') })));
};
export default ShorthaulOperations;
